import React, { useEffect, useState } from "react";
import {
  Header,
  Group,
  Container,
  Text,
  ActionIcon,
  Menu,
  Button,
  useMantineTheme,
} from "@mantine/core";
import { randomId, useIdle } from "@mantine/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { HeaderSafraLinkLogo } from "components/LogoSafraLinkAndFdic";
import { GetUserInfoCIF, GetUserMenu } from "services/user";
import {
  getToken,
  getTokenIdentifier,
  getTokenUser,
  isAuthenticated,
  Logout,
} from "services/auth";
import { useMessageBox } from "hooks/useMessageBox";

import UseStyles from "./useStyles";
import { useFilterData } from "hooks/useFilterData";

export default function HearderPage(props) {
  const [itemMenu, setItemMenu] = useState([]);
  const theme = useMantineTheme();
  const { classes } = UseStyles();
  const navigate = useNavigate();
  const { showMessage } = useMessageBox();
  const idleFirst = useIdle(process.env.REACT_APP_SESSIONEXPIREDTIME_MSG, {
    initialState: false,
  });
  const idleSecond = useIdle(process.env.REACT_APP_SESSIONEXPIREDTIME, {
    initialState: false,
  });

  const filterData = useFilterData();

  useEffect(() => {
    if (idleFirst === true) {
      showMessage({
        type: "warning",
        message:
          "Your session will expire in 2 minutes, press OK to stay logged on. Your session data will be lost upon disconnection.",
      });
    }
  }, [idleFirst]);

  useEffect(() => {
    if (idleSecond === true) {
      Logout();
      window.location = process.env.REACT_APP_SITE_LOGOUT;
    }
  }, [idleSecond]);

  useEffect(() => {
    GetUserMenu().then((data) => {
      if (data !== undefined && data !== null) {
        if (data.Return !== undefined && data.Return !== null) {
          if (data.Return.Menus !== undefined && data.Return.Menus) {
            setItemMenu(data.Return.Menus);
          }
        }
      }
    });

    if (isAuthenticated() === true) {
      if (filterData.GetCIFList().length === 0) {
        LoadCIF();
        navigate("/");
      }
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated() === false) {
      navigate("/unauthorized", { replace: true });
    }
  }, [itemMenu]);

  const LoadCIF = async () => {
    const cifs = await GetUserInfoCIF(
      getToken(),
      getTokenIdentifier(),
      getTokenUser()
    );

    filterData.SetCIFList(cifs);
  };

  const menus = itemMenu.map((item) => (
    <Menu
      key={randomId()}
      position="bottom-start"
      offset={0}
      trigger="hover"
      radius={0}
      shadow="lg"
    >
      {item.SubMenus.length > 0 && (
        <Menu.Target>
          <Button
            onClick={(event) => event.preventDefault()}
            className={classes.button}
            pl={32}
            pr={32}
          >
            {item?.DscFunctionDisplayName}
          </Button>
        </Menu.Target>
      )}
      {item.SubMenus.length === 0 && (
        <Menu.Target>
          <Button
            className={classes.button}
            component="a"
            href={item?.DscSystemFuncionView}
            pl={32}
            pr={32}
          >
            {item?.DscFunctionDisplayName}
          </Button>
        </Menu.Target>
      )}
      {item.SubMenus.length > 0 && (
        <Menu.Dropdown>
          {item.SubMenus.map((submenu) =>
            submenu?.SubMenus.length === 0 ? (
              <Menu.Item
                key={randomId()}
                className={classes.textMenu}
                component="a"
                href={submenu?.DscSystemFuncionView}
              >
                {submenu?.DscFunctionDisplayName}
              </Menu.Item>
            ) : (
              <Menu.Item key={randomId()} m={0} p={0}>
                <Menu
                  trigger="hover"
                  position="right-start"
                  offset={5}
                  radius={0}
                  shadow="lg"
                >
                  <Menu.Target>
                    <Text
                      onClick={(event) => event.preventDefault()}
                      className={classes.textMenu}
                    >
                      {submenu?.DscFunctionDisplayName}
                    </Text>
                  </Menu.Target>
                  <Menu.Dropdown>
                    {submenu?.SubMenus?.map((subitem) => (
                      <Menu.Item
                        key={randomId()}
                        component="a"
                        href={subitem?.DscSystemFuncionView}
                        className={classes.textMenu}
                        style={{
                          width: "280px",
                        }}
                      >
                        {subitem.DscFunctionDisplayName}
                      </Menu.Item>
                    ))}
                  </Menu.Dropdown>
                </Menu>
              </Menu.Item>
            )
          )}
        </Menu.Dropdown>
      )}
    </Menu>
  ));

  return (
    <div>
      <div className={classes.line} />
      <Header className={classes.header} mb={10}>
        <Container size="lg">
          <Group position="apart" mt="3px" mb="5px">
            <HeaderSafraLinkLogo height="50" />
            <Group spacing="xs" className={classes.links}>
              {isAuthenticated() === true && (
                <ActionIcon
                  variant="light"
                  radius="xl"
                  size={28}
                  component="a"
                  href={process.env.REACT_APP_MAILBOX}
                >
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    style={{ color: theme.colors["deep-blue"][0] }}
                  />
                </ActionIcon>
              )}
            </Group>
          </Group>
        </Container>

        {isAuthenticated() === true && (
          <div style={{ height: "40px" }}>
            <div style={{ background: "#FFF", height: "1px" }} />
            <Group spacing="0px" position="center" className={classes.menu}>
              {menus}
            </Group>
          </div>
        )}
      </Header>
    </div>
  );
}
